/***
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-06-01 03:06:54
 * @FilePath: \gcp-fe\src\main.js
 * @Description:main.js js主入口文件
 */
import Vue from "vue";
import vueSwiper from "vue-awesome-swiper";
import "babel-polyfill"; // 兼容低版本IE,ES5模拟ES6新语法
import App from "./App.vue"; // 当前项目的挂载容器
import router from "./basa/router"; // vue路由
import store from "./config/store"; // vuex
import globalComponents from "@/basa/common-set/globalComponents"; // 挂载的平台级公共函数
import appComponents from "@/config/app-set/appComponents"; // 自定义挂载应用级的公共函数
import CCUI from "@/config/app-set/ccui"; // ccui组件库配置文件，用来增删工程内用到的组件
import "./permission"; // 全局路由守卫等全局控制器
import "./config/icons"; // SVG
// import "./config/mock"; // mock数据
import { Select, Option } from "element-ui";
import Cookies from "js-cookie";
import i18n from "@/config/i18n";

// iconfont 图标
import "@/app/font_1886479_aicgfdudvqe/iconfont.css";
import "@/config/styles/index.scss"; // 项目所用公共css
import "swiper/dist/css/swiper.css";
import * as filters from "./basa/filters"; // 全局过滤器
import functions from "./basa/utils/functions"; // 全局方法
import searchComponents from "@/basa/components/search-component"; // 高级搜索所需自定义特殊组件
import { tableThWidth } from "@/setting/setting.js";
import {
  qrySupCodeByOpenId,
  getSubcontractInfoByLoginInfo
} from "./app/procurementNotice/api/shopping";

if (window) window.$t = (key, value) => i18n.t(key, value);

// import VueMatomo from "vue-matomo"; // 访问量所需插件
// 注册全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
Vue.prototype.$TW = tableThWidth;
if (window) window.$TW = tableThWidth;
// 生产环境不显示vue警告信息
Vue.config.productionTip = false;
// 注册全局方法
Vue.use(functions);
// 注册ccui组件
Vue.use(CCUI);
Vue.use(searchComponents);
// 注册平台级公共组件
Vue.use(globalComponents);
// 注册一些应用级组件
Vue.use(appComponents);

Vue.use(vueSwiper);

// 在Vue中注册Element UI的下拉框组件
Vue.use(Select);
Vue.use(Option);

//全局组件
import listBaseTable from "@/basa/components/common/listBaseTable";
import computeUtil from "./config/utils/bigNumber";

Vue.component("listBaseTable", listBaseTable);
// 计算
window.$computeUtil = computeUtil;

// 判断是否已登录
if (Cookies.get("access_token")) {
  // 在 new Vue 之前调用 qrySupCodeByOpenId
  qrySupCodeByOpenId().then(res => {
    if (res.data.code == 0) {
      sessionStorage.setItem("supCodeList", res.data.data.supCodeList);
    }
  });

  // 在 new Vue 之前调用 getSubcontractInfoByLoginInfo
  getSubcontractInfoByLoginInfo().then(res => {
    if (res.data.code == 0) {
      let isInterSup = "1";
      if (res.data.data.getSupInfoByLoginInfoRspBOList.length > 0) {
        res.data.data.getSupInfoByLoginInfoRspBOList.forEach(item => {
          if (item.isInterSup == "0") {
            isInterSup = "0";
          }
        });
        sessionStorage.setItem("fbSupCode", res.data.data.supCode);
      } else {
        sessionStorage.setItem("fbSupCode", 10000);
      }
      sessionStorage.setItem("isInterSup", isInterSup);
      let subcontractInfo = res.data.data.getSupInfoByLoginInfoRspBOList.map(
        item => item.supCode
      );
      sessionStorage.setItem("subcontractInfo", subcontractInfo);
      sessionStorage.setItem(
        "usedSupInfo",
        JSON.stringify(res.data.data.getSupInfoByLoginInfoRspBOList[0])
      );
    }
  });
} else {
  localStorage.clear();
  sessionStorage.clear();
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
